export const FLOW_NAME = "forecasting";
export type FLOW_TYPE = "forecasting";

export const INPUT_DATA = "data";

export const TIMESTAMP_VAR_KEY = "time";
export const TARGET_VAR_KEY = "y-column";
export const ACTIONABLE_VARS_KEYS = "action-variables";
export const GROUPING_VARS_KEY = "grouping-variables";

export const RESOLUTION_KEY = "resolution";
export const ADDITIVE_VARS_KEY = "additive-variables";
export const TRAIN_TEST_SPLIT_KEY = "train-test-split-dt";

export const RECIPE_NAME = "forecasting-driver-analysis";

export const RUN_ID = "RUN_ID";
export const INIT_RUN = "INIT_RUN";
export const CREATED_BY = "CREATED_BY";
export const TIME_STAMP = "TIME_STAMP";

export const SMALL_DATA_ALGORITHMS = ["bayesian-nig"];
export const ALGORITHMS = ["boosted-trees", "bayesian-nig"];

export const IS_APP_KEY = "is-app";
export const APP_MODEL_KEY = "model-for-app";
